import { removeKey } from '@/services/persistence'

export const analyzeCloseCartResult = (data) => {
  const { status } = data.data
  return status !== 'open'
}

export const purgeCartData = async () => {
  await removeKey('cart')
}

// The API answers 409 CART_NOT_OPEN to a change on a closed cart (Q-100)
export const isCartNotOpen = (err) =>
  err?.response?.status === 409 && err.response.data?.error === 'CART_NOT_OPEN'

// The API answers 409 CART_EMPTY to a close on a cart with no lines (Q-175)
export const isCartEmpty = (err) =>
  err?.response?.status === 409 && err.response.data?.error === 'CART_EMPTY'

// The API answers 403 CART_NOT_OWNED when the cart has another owner (Q-101)
export const isCartNotOwned = (err) =>
  err?.response?.status === 403 && err.response.data?.error === 'CART_NOT_OWNED'

// Runs a cart change. If the cart was closed meanwhile, or belongs to someone
// else (a shared device after a logout), starts a new cart and runs the change
// once more: `change` must read the cart uuid when called.
export const withUsableCart = async (change, startNewCart) => {
  try {
    return await change()
  } catch (err) {
    if (!isCartNotOpen(err) && !isCartNotOwned(err)) throw err
    await startNewCart()
    return change()
  }
}

// The amount Redsys charges: the discounted total when there is one, as
// amount_to_pay_key in api/src/django/cart/service/payment.py (Q-222)
export const amountToPay = (cart) =>
  cart.acc_discount_total_gross_and_delivery ||
  cart.acc_total_gross_and_delivery

// The API refuses a card payment above the shop's max_card_payment (Q-109)
export const cardPaymentAllowed = (cart, maxCardPayment) =>
  !maxCardPayment || maxCardPayment >= amountToPay(cart)

// The net, VAT and recargo the cart summary lists. With afterCode and a promo
// code, the ones after the code, which add up to acc_discount_total_gross
// (Q-219, Q-224); otherwise the ones before the code.
export const cartBreakdown = (cart, afterCode) => {
  if (afterCode && cart.acc_discount_total_net != null) {
    return {
      net: cart.acc_discount_total_net,
      taxes: cart.acc_discount_total_taxes,
      recargo: cart.recargo_equivalencia_discount || [],
    }
  }
  return {
    net: cart.acc_total_net,
    taxes: cart.acc_total_taxes,
    recargo: cart.recargo_equivalencia || [],
  }
}
